import { useCallback, useState } from "react";
import { SignInRequest } from "@serviestate/shared/types";
import { LoginTemplate } from "../templates/login";
import { Navigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useAPI } from "../../hooks/use-api";
import { useAuthProvider } from "../../providers/auth.provider";
import { useQueryString } from "../../hooks/use-query-string";

export default function LoginPage() {
  const api = useAPI();
  const {
    query: { redirect },
  } = useQueryString();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [jwt, setJwt] = useAuthProvider();

  const handleLogin = useCallback(
    async (form: SignInRequest) => {
      setLoading(true);
      try {
        try {
          const response = await api.auth.signIn(form);
          api.setCredentials(response.access_token);
          setJwt(response.access_token);
          enqueueSnackbar(`Bienvenido ${response.fullname}`, {
            variant: "success",
          });
        } catch (e) {
          enqueueSnackbar("Las credenciales no son válidas", {
            variant: "error",
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [api, enqueueSnackbar, setJwt]
  );

  if (jwt.isAuthenticated) {
    return <Navigate to={(redirect as string) ?? "/"} replace />;
  }

  return <LoginTemplate loading={loading} onSubmit={handleLogin} />;
}
